module.exports = __webpack_public_path__ + "static/media/Jialin Zhuo.f67abb24.JPG";